import styled from '@emotion/styled';
import { IApp, ILauncherGrid } from 'types';
import { useLauncherStrategyProvider } from 'lib/launchStrategies/LauncherStrategyProvider';
import Img from 'components/Img';
import defaultIcon from './defaultIcon';
import { Button } from '@mui/material';

const StyledGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  max-width: 400px;
  min-width: 300px;

  .grid-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 33%;
    margin-bottom: 8px;
    cursor: pointer;
    min-width: 90px;

    .subtitle,
    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      color: #1a416b;
    }

    .grid-item-text {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .icon {
      max-width: 46%;
      margin-bottom: 4px;
    }
    .title {
      font-weight: 700;
    }
    .subtitle {
      font-size: 0.9rem;
      color: #bcc9d4;
    }
  }

  @media (max-width: 600px) {
    .grid-item {
      width: 50%;
      .icon {
        max-width: 30%;
      }
    }
  }
`;

const Item = ({
  data,
  closeHandler,
  logoHandler,
}: {
  data: IApp;
  closeHandler: () => void;
  logoHandler: (data: IApp) => void;
}) => {
  const { launchApplication } = useLauncherStrategyProvider();
  // const { setIsDefaultApp } = useInitProvider();
  return (
    <Button
      variant="text"
      color="primary"
      className="grid-item"
      style={{ padding: '8px', height: 'auto' }}
      onClick={() => {
        closeHandler();
        launchApplication(data);
        logoHandler(data);
        // setIsDefaultApp(false);
      }}
    >
      <Img
        className="icon"
        src={data.icon}
        altSrc={defaultIcon}
        alt={data.label || ''}
      />
      <div className="grid-item-text">
        {data.type === 'int' ? (
          <div className="subtitle">{data.subtitle}</div>
        ) : null}
        <div className="title">{data.label || ''}</div>
        {/* <Typography variant="subtitle2">Requiro</Typography>
  <Typography variant="button">{data.label || ''}</Typography> */}
      </div>
    </Button>
  );
};

const Grid = ({ children }: ILauncherGrid) => {
  return <StyledGrid className="StyledGrid">{children}</StyledGrid>;
};

export { Grid, Item };
